import {
    BalloonEventsQuery,
    QueryModel,
    mergeQueries,
} from 'ts-core';
import React, {useEffect, useRef, useState} from 'react';
import {useBalloonEventsData} from '../contexts/EventData';
import {Fits} from 'ts-core';

const filterTypes = [
    // {
    //     Icon: () => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-8 h-8">
    //         <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 6h9.75M10.5 6a1.5 1.5 0 1 1-3 0m3 0a1.5 1.5 0 1 0-3 0M3.75 6H7.5m3 12h9.75m-9.75 0a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m-3.75 0H7.5m9-6h3.75m-3.75 0a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m-9.75 0h9.75" />
    //     </svg>,
    //     selector: (queries: BalloonEventsQuery[]) => queries.filter(q => q.dates || q.categories || q.text),
    //     text: "Filter",
    //     className: "bg-red-500 text-white shadow-lg"
    // },
    {
        Icon: () => (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="w-8 h-8"
            >
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5"
                />
            </svg>
        ),
        selector: (queries: BalloonEventsQuery[]) => queries.filter((q) => q.dates),
        text: 'Datum',
        className: 'bg-yellow-200 text-yellow-900 shadow-lg',
    },
    {
        Icon: () => (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="w-8 h-8"
            >
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M9.568 3H5.25A2.25 2.25 0 0 0 3 5.25v4.318c0 .597.237 1.17.659 1.591l9.581 9.581c.699.699 1.78.872 2.607.33a18.095 18.095 0 0 0 5.223-5.223c.542-.827.369-1.908-.33-2.607L11.16 3.66A2.25 2.25 0 0 0 9.568 3Z"
                />
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M6 6h.008v.008H6V6Z"
                />
            </svg>
        ),
        selector: (queries: BalloonEventsQuery[]) =>
            queries.filter((q) => q.categories),
        text: 'Kategorie',
        className: 'bg-blue-200 text-blue-900 shadow-lg',
    },
    {
        Icon: () => (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="w-8 h-8"
            >
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"
                />
            </svg>
        ),
        selector: (queries: BalloonEventsQuery[]) => queries.filter((q) => q.text),
        text: 'Text',
        className: 'bg-purple-200 text-purple-900 shadow-lg',
    },
    /*{
      Icon: () => (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="currentColor"
          className="w-8 h-8"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
          />
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z"
          />
        </svg>
      ),
      selector: (queries: BalloonEventsQuery[]) => queries.filter((q) => q.bbox),
      text: 'Karte',
      className: 'bg-gray-200 text-gray-900 shadow-lg',
      isButton: true,
    },*/
];

export function QueryFeed({
                              queries,
                              removeQuery,
                          }: {
    queries: BalloonEventsQuery[];
    removeQuery: (id: string) => void;
}) {
    const [expanded, setExpanded] = useState(false);

    const [pointerDown, setPointerDown] = useState(false);

    useEffect(() => {
        if (!expanded) return;
        const timeout = setTimeout(() => {
            setExpanded(false);
        }, 5000);
        return () => clearTimeout(timeout);
    }, [pointerDown]);

    return (
        <div className="flex flex-col items-end space-y-2">
            {filterTypes.map((filter, i) => {
                const filterQueries = filter.selector(queries);
                if (filterQueries.length === 0) return null;
                return (
                    <QueryBadge
                        expanded={expanded}
                        setPointerDown={(down) => {
                            if (down) setExpanded((ex) => !ex);
                            setPointerDown(down);
                        }}
                        Icon={filter.Icon}
                        key={i}
                        text={filter.text}
                        className={filter.className}
                        queries={filterQueries}
                        removeQuery={removeQuery}
                    />
                );
            })}
        </div>
    );
}

export function QueryBadge({
                               text,
                               className,
                               queries,
                               removeQuery,
                               Icon,
                               expanded,
                               setPointerDown,
                           }: {
    text: string;
    className: string;
    queries: BalloonEventsQuery[];
    removeQuery: (id: string) => void;
    Icon: () => React.ReactElement;
    expanded?: boolean;
    setPointerDown?: (expanded: boolean) => void;
}) {
    const queryModelRef = useRef<QueryModel>(new QueryModel(false));

    const {eventMap, events} = useBalloonEventsData();

    const [hidden, setHidden] = useState(0);

    useEffect(() => {
        queryModelRef.current.set(mergeQueries(queries));
        const allEvents = [...eventMap.values()];
        setHidden(
            allEvents.filter((e) => queryModelRef.current.fits(e) === Fits.NO).length
        );
    }, [queries, events]);

    return (
        <div
            className={
                'rounded-lg text-lg px-1 flex my-2 pointer-events-auto w-full items-center justify-between ' +
                className
            }
        >
            <div>
                <ExpandableQueryBadgeContent
                    expanded={expanded}
                    setPointerDown={setPointerDown}
                    hidden={hidden}
                    text={text}
                >
                    <Icon/>
                </ExpandableQueryBadgeContent>
            </div>
            <button onClick={() => queries.forEach((q) => q.id && removeQuery(q.id))}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="w-5 h-5"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M6 18 18 6M6 6l12 12"
                    />
                </svg>
            </button>
        </div>
    );
}

function ExpandableQueryBadgeContent({
                                         hidden,
                                         text,
                                         children,
                                         expanded,
                                         setPointerDown,
                                     }: {
    hidden: number;
    text: string;
    children?: React.ReactNode;
    expanded?: boolean;
    setPointerDown?: (expanded: boolean) => void;
}) {
    return (
        <div
            className="flex items-center"
            onPointerUp={() => setPointerDown?.(false)}
            onPointerDown={() => {
                setPointerDown?.(true);
            }}
        >
            {children}
            {expanded && <ExpandedQueryBadgeContent hidden={hidden} text={text}/>}
        </div>
    );
}

function ExpandedQueryBadgeContent({
                                       hidden,
                                       text,
                                   }: {
    hidden: number;
    text: string;
}) {
    return (
        <div className="flex flex-col justify-center items-start animate-opacity-up">
            <span className="font-medium">{text} aktiv</span>
        </div>
    );
}

//{hidden > 0 && <span className="text-sm">{hidden} ausgeblendet</span>}
